interface RouterHistoryState {
  idx?: unknown;
}

export type BackDestination =
  | { to: -1; replace: false }
  | { to: string; replace: true };

export const resolveBackDestination = (
  historyState: unknown,
  fallbackPath: string,
): BackDestination => {
  if (typeof historyState === 'object' && historyState !== null) {
    const historyIndex = (historyState as RouterHistoryState).idx;
    if (typeof historyIndex === 'number' && historyIndex > 0) {
      return { to: -1, replace: false };
    }
  }

  return { to: fallbackPath, replace: true };
};
